import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { head } from 'lodash';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { AccountPaymentTable } from 'web-ui-components/lib/finance/accounts';
import withContent from '../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from '../PaymentDetails/bacs/BacsPayment.content';
import { formatDate, formatLongDateTime } from '../../utils/dateUtils';
import { formatAccountDetails } from '../../utils/accountUtils';
import { verificationPropTypes } from '../../states/payments/propTypes';
import { formatAmount } from '../../utils/numberUtils';
import { getMyDataForFileUpload } from '../../utils/paymentsUtils';

const AuthoriseBacsCreditPaymentDetails = ({ content, payment }) => {
	const {
		title,
		fromLabel,
		toLabel,
		amountLabel,
		refLabel,
		createdByLabel,
		createdOnLabel,
		bacsTypeLabel,
		bacsCreditLabel,
		hmrcRefLabel,
		bacsIdLabel,
		submissionDateLabel,
		settlementDateLabel,
		totalAmountLabel,
		individualPaymentsLabel,
		transactions,
	} = content;
	const { created_timestamp, total, bacs } = payment;
	const { creator_name, from_account, bacs_id, submission_date, settlement_date } = head(payment.payments);
	const headerBacsCredit = [
		{ type: 'account', label: toLabel },
		{ type: 'currency', label: amountLabel },
		{ type: 'iban', label: refLabel },
		{ type: 'iban', label: hmrcRefLabel },
	];

	const bacsCreditPaymentInformationData = (bacsPayment) => [
		{ headerText: toLabel, cellText: formatAccountDetails(bacsPayment.to_account) },
		{ headerText: amountLabel, cellText: formatAmount(bacsPayment.amount) },
		{ headerText: refLabel, cellText: bacsPayment.reference },
		{ headerText: hmrcRefLabel, cellText: bacsPayment.hmrc_reference },
	];

	const rows = [].concat(...getMyDataForFileUpload(payment.payments));

	const paymentInformationTable = () => {
		if (bacs.file_upload) {
			return <AccountPaymentTable headerData={headerBacsCredit} tableData={rows} />;
		}
		return payment.payments.map((bacsPayment) => (
			<div key={bacsPayment.id} className="u-margin-y-1">
				<Grid.TwoThirds>
					<VerticalReviewTable data={bacsCreditPaymentInformationData(bacsPayment)} />
				</Grid.TwoThirds>
			</div>
		));
	};

	const authoriseBacsCreditPaymentData = [
		{ headerText: bacsTypeLabel, cellText: bacsCreditLabel },
		{ headerText: fromLabel, cellText: formatAccountDetails(from_account) },
		{ headerText: bacsIdLabel, cellText: bacs_id },
		{ headerText: submissionDateLabel, cellText: formatDate(submission_date) },
		{ headerText: settlementDateLabel, cellText: formatDate(settlement_date) },
		{ headerText: bacs.file_upload ? transactions : individualPaymentsLabel, cellText: payment.payments.length },
		{ headerText: totalAmountLabel, cellText: formatAmount(total) },
		{ headerText: createdByLabel, cellText: creator_name },
		{ ...(created_timestamp ? { headerText: createdOnLabel, cellText: formatLongDateTime(created_timestamp) } : []) },
	];

	return (
		<div>
			<SectionHeading>{title}</SectionHeading>
			<Grid.TwoThirds>
				<VerticalReviewTable data={authoriseBacsCreditPaymentData} />
			</Grid.TwoThirds>
			{paymentInformationTable()}
		</div>
	);
};

AuthoriseBacsCreditPaymentDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
};

const contentWrapper = withContent({ content: paymentDetailsContent });
export default connect()(contentWrapper(AuthoriseBacsCreditPaymentDetails));
export const ConnectWrapper = connect()(AuthoriseBacsCreditPaymentDetails);
